<script setup lang="ts">
  import { RouteLocationRaw } from '#vue-router';
  import { AlmaCookiesSettingsButton } from '#components';

  interface InfoLink {
    to: RouteLocationRaw;
    label: string;
  }

  const { t } = useI18n();
  const projectConfig = useProjectConfig();

  const almaCookiesSettingsButton = AlmaCookiesSettingsButton;

  const links = computed(() => {
    const items: (InfoLink | typeof AlmaCookiesSettingsButton)[] = [
      {
        to: { name: 'info-slug', params: { slug: t('BRAND_LINKS.CONTACT.SLUG') } },
        label: t('BRAND_LINKS.CONTACT.LABEL'),
      },
      {
        to: projectConfig.parameters.meetUsLink || 'https://www.almacareer.com/',
        label: t('BRAND_LINKS.MEET_US.LABEL'),
      },
      {
        to: { name: 'info-slug', params: { slug: t('BRAND_LINKS.TOS.SLUG') } },
        label: t('BRAND_LINKS.TOS.LABEL'),
      },
      {
        to: { name: 'info-slug', params: { slug: t('BRAND_LINKS.PRIVACY.SLUG') } },
        label: t('BRAND_LINKS.PRIVACY.LABEL'),
      },
    ];

    if (projectConfig.features.almaCookieManager) {
      items.push(almaCookiesSettingsButton);
    }

    return items;
  });
</script>

<template>
  <slot :links="links" />
</template>
